import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router";
import store from "./reduxStore/store";
import { Provider } from "react-redux";

import PrivateRoute from "./components/privateRoute";
import Login from "./components/login";
import ResetPassword from "./components/resetPassword";
import ForgotPassword from "./components/forgotPassword";
import MyAccount from "./components/myAccount";
import AccountSettings from "./components/myAccount/accountSettings";
import AccountSummary from "./components/myAccount/accountSummary";
import MyAccountPayments from "./components/myAccount/payments";
import ServiceDetails from "./components/myAccount/myServices";
import MyDocuments from "./components/myAccount/myDocuments";


import Header from "./components/header";
import Footer from "./components/footer";
import Invoices from "./components/invoices";
import ChangePasswordComponent from "./components/myAccount/accountSettings/changePassword";
import AppointmentScheduler from "./components/appointmentScheduler";

import EasyPaySettings from "./components/myAccount/accountSettings/easypay-settings/easypaysettings";
import Preferences from "./components/myAccount/accountSettings/easypay-settings/update-easypay-preferences/preferences";
import SuccessPayment from "./components/myAccount/accountDetailsSharedBlocks/SuccessPayment";
import PaymentSuccessEP from "./components/myAccount/payments/easypay-payments/successPayment";
import EasyPayMain from "./components/myAccount/accountSettings/easypay-settings/EasyPayMain";
import PrePayPayment from "./components/myAccount/payments/prepay-payment/PrePayPayment";
import OneTimePayment from "./components/myAccount/payments/one-time-payment/oneTimePayment";
import EasyPayPayment from "./components/myAccount/payments/easypay-payments/easyPayPayments";
import Enroll from "./components/myAccount/payments/easyPaySettingPayments/enroll";
import Loader from "./components/loader";
import ApiErrorNotification from "./components/globalError/ApiErrorNotification";

const ViewPayment = lazy(() => import("./components/myAccount/accountSettings/payment-methods/paymentMethods"));

const App = () => {
  return (
    <Provider store={store}>
      <Router> 
        <ApiErrorNotification />
        <Header />
        <div
          className="d-none d-sm-block"
          style={{ height: "150px" }}
        ></div>{" "}
        {/* Spacer to prevent content being hidden behind fixed header */}
        <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Login />} />

          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/appointment-scheduler" element={<AppointmentScheduler />} />
          <Route
            path="/my-invoices"
            element={
              <PrivateRoute>
                <Invoices />{" "}
              </PrivateRoute>
            }
          />

          <Route
            path="/my-account"
            element={
              <PrivateRoute>
                <MyAccount />
              </PrivateRoute>
            }
          >
            <Route path="account-summary" element={<AccountSummary />} />

            <Route path="payments" element={<MyAccountPayments />}>
              <Route index element={<MyAccountPayments />} />
              <Route path="easypay-payment" element={<EasyPayPayment />} />
              <Route path="prepay-payment" element={<PrePayPayment />} />
              <Route path="one-time-payment" element={<OneTimePayment />} />
              <Route path="enroll" element={<Enroll />}></Route>
              <Route path="easypay-success-payment" element={<PaymentSuccessEP />} />
            </Route>

            <Route path="my-services" element={<ServiceDetails />} />

            <Route path="account-settings" element={<AccountSettings />}>
              <Route path="payment-methods" element={<ViewPayment />} />
              <Route path="change-password" element={<ChangePasswordComponent />} />

              <Route path="easypay-settings" element={<EasyPayMain />}>
                <Route index element={<EasyPaySettings />} />
                <Route path="update-easypay-preferences" element={<Preferences />} />
                <Route path="update-easypay-success" element={<SuccessPayment />} />
              </Route>

            </Route>

            <Route path="my-documents" element={<MyDocuments />} />

          </Route>
        </Routes>
        </Suspense>
        <Footer />
      </Router>
    </Provider>
  );
};

export default App;
